export enum RestApiResponseFormatType {
    Text = 'Text',
    Json = 'Json',
    Xml = 'Xml',
}
